import React from 'react';
import { ReactComponent as RaisedHandIcon } from '../../images/svg/raisedHand.svg';
import { ReactComponent as EditProfile } from '../../images/svg/user-edit.svg';
import screenshare from '../../images/screenshare.gif';

const ParticipantItem = ({ id, name, role, getAvatarColor, hasRaisedHand, isSharingScreen, onLocalUserClick }) => {
  let participantName = '';

  if (name) {
    if (name.length > 17) {
      participantName = name.substring(0, 17) + '...';
    } else {
      participantName = name;
    }
  } else {
    participantName = "Guest User";
  }

  const isLocalUser = role === 'You as Guest';

  return (
  <div className="single-participant">
    <div 
      className="participant-avatar"
      style={{ background: getAvatarColor(id), cursor: isLocalUser ? 'pointer' : 'default' }}
      onClick={isLocalUser ? onLocalUserClick : undefined}
    >
      {participantName[0]}
    </div>
    <div className="participant-name-container">
      <div 
        className="participant-name-text" 
        // style={{ cursor: isLocalUser ? 'pointer' : 'default' }}
        // onClick={isLocalUser ? onLocalUserClick : undefined}
      > 
        <div className="participant-name">{participantName}
        {name.length > 17 && <div className="toolbox-tooltip">{name}</div>}
        </div> 
        <span className="role-text">({role})</span> 
        {hasRaisedHand && <RaisedHandIcon className="raised-hand-icon" />}
        {/* {isLocalUser && <span onClick={onLocalUserClick} className="edit-profile-icon"><EditProfile />
        <div className="toolbox-tooltip">Edit Profile</div>
        </span>} */}
      </div>
      
      {isSharingScreen && (
        <div className="screen-share-status">
          <img src={screenshare} alt="screen-share" className="screen-share-icon" /> Sharing Screen
        </div>
      )}
    </div>

  </div>
  );
};

export default ParticipantItem;